import { FC, CSSProperties } from 'react'
import { FlexContainer, MainContainer, PageContainer, Text3XL, TextXL } from '@reapit/elements'

const styles = {
  pageContainer: {
    textAlign: 'center',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#ffffff',
    overflowY: 'auto',
  } as CSSProperties,
}

export const NetworkErrorPage: FC = () => {
  return (
    <MainContainer>
      <FlexContainer isFlexGrow1 isFlexAlignCenter isFlexJustifyCenter>
        <PageContainer hasMaxWidth style={styles.pageContainer}>
          <Text3XL intent="default" className="el-pb4">
            This Isn’t Accessible Here Just Yet
          </Text3XL>
          <TextXL intent="default" className="el-pb8">
            Sorry, this system isn’t available through the system switcher right now.
            <br />
            Please continue using your existing
            <strong> .agentboxcrm.com.au</strong> login for now.
            <br />
            If you need help, reach out to Support.
          </TextXL>
        </PageContainer>
      </FlexContainer>
    </MainContainer>
  )
}
